<template>
  <button
    @click="onClick"
    aria-label="Continue"
    style="background: transparent; border: 0; height: 75px; width: 75px"
    :tabindex="!removeTabIndex ? '11' : ''"
    class="in-activity-button"
  >
    <forward-icon height="75" width="75"></forward-icon>
  </button>
</template>

<script>
import ForwardIcon from 'components/icons/ForwardIcon.vue';

export default {
  props: {
    onClick: {
      type: Function,
      default: () => {},
      required: true
    },
    removeTabIndex: {
      type: Boolean,
      required: false
    }
  },
  components: {
    ForwardIcon
  }
};
</script>
